import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';

import { useFnol } from '../../../context';

import { PrimaryButton, SecondaryButton } from '../../../components';
import { QuestionNode } from '.';

import { STEP_UPLOAD_FILE, STEP_IDENTIFY_CUSTOMER } from '../../../CONSTANTS';
import ButtonWrapper from '../../../components/ButtonWrapper';

const QuestionList = () => {
  const { fnolAnswers, fnolTemplate, setFnolAnswers, setStep } = useFnol();

  const { t } = useTranslation();

  const [formIsValid, setFormIsValid] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setStep(STEP_UPLOAD_FILE);
  };

  const handleChange = (id, value, dataType) => {
    setFnolAnswers({ [id]: { id, value, dataType } });
  };

  const handleGoBackClick = () => setStep(STEP_IDENTIFY_CUSTOMER);

  useEffect(() => {
    const answerIsValid = (contents, key) => {
      if (
        contents.listOfquestionTreeOut &&
        contents.listOfquestionTreeOut?.length > 0
      ) {
        if (
          !contents.listOfquestionTreeOut.every((question) =>
            answerIsValid(
              question,
              `${key}_${
                question.tag === 'QuestionNode'
                  ? question.question.key
                  : question.answeredQuestion.key
              }`
            )
          )
        )
          return false;
      }

      if (
        fnolAnswers[key]?.dataType === 'Day' ||
        fnolAnswers[key]?.dataType === 'Time'
      ) {
        return fnolAnswers[key].value ? true : false;
      }

      return (fnolAnswers[key]?.value.trim().length ?? 0) > 0;
    };

    if (fnolTemplate) {
      setFormIsValid(
        fnolTemplate.questions
          .filter((question) => question.tag === 'Mandatory')
          .every((question) =>
            answerIsValid(
              question.contents,
              question.contents.tag === 'QuestionNode'
                ? question.contents.question.key
                : question.contents.answeredQuestion.key
            )
          )
      );
    }
  }, [fnolAnswers, fnolTemplate]);

  return (
    <>
      {fnolTemplate && fnolTemplate.introductionMarkdown && (
        <ReactMarkdown
          linkTarget='_blank'
          children={fnolTemplate.introductionMarkdown}
        />
      )}
      <form onSubmit={handleSubmit}>
        {fnolTemplate &&
          fnolTemplate.questions &&
          fnolTemplate.questions.map((question) => (
            <QuestionNode
              key={
                question.contents.question
                  ? question.contents.question.key
                  : question.contents.answeredQuestion.key
              }
              id={
                question.contents.question
                  ? question.contents.question.key
                  : question.contents.answeredQuestion.key
              }
              contents={question.contents}
              isMandatory={question.tag === 'Mandatory'}
              onChange={handleChange}
            />
          ))}
        <ButtonWrapper>
          <SecondaryButton onClick={handleGoBackClick}>
            {t('buttons.back')}
          </SecondaryButton>
          <PrimaryButton type='submit' disabled={!formIsValid}>
            {t('buttons.continue')}
          </PrimaryButton>
        </ButtonWrapper>
      </form>
    </>
  );
};

export default QuestionList;
